module.exports = __webpack_public_path__ + "style/img/Group 1952(1).daf79ba5.png";